import React from 'react'
import clsx from 'clsx'
import { useTheme } from '@mui/material'
import LayoutMain from '../layouts/Main'
import LayoutBase from '../layouts/Base'
import DeviceConnection from '../components/DeviceConnection'
import HomeActions from '../components/HomeActions'

export default function HomePage() {
  const theme = useTheme()

  return (
    <LayoutBase>
      <LayoutMain>
        <div className="relative w-full pb-14">
          <div
            className={clsx('absolute top-0 left-0 w-full h-[400px] ', {
              'bg-opacity-[0.05] bg-white': theme.isDark,
              'bg-opacity-[0.05] bg-gray-500': !theme.isDark
            })}
          />
          <div
            className={clsx('absolute top-0 left-0 w-full h-[550px]', {
              'bg-opacity-[0.05] bg-white': theme.isDark,
              'bg-opacity-[0.05] bg-gray-500': !theme.isDark
            })}
          />
          <div className="relative py-8 md:py-12">
            <div className="mx-auto w-full md:max-w-[1300px] px-2 md:px-12 space-y-10">
              <DeviceConnection />
              {/* Os atalhos vêm depois do estado da conexão: primeiro o cliente
                  vê se o número está no ar, depois o que pode fazer com ele. */}
              <HomeActions />
            </div>
          </div>
        </div>
      </LayoutMain>
    </LayoutBase>
  )
}
